import type { FC, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ErrorHint, Loadable, Modal as ModalComponent } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"
import { type IUseTranslation, useTranslation } from "@/hooks"

import ModalBody from "./attendance.early.modal.body.component"
import elements from "./attendance.modal.elements"
import classes from "./attendance.modal.styles"

/**
 * 'Early attendance' modal
 * Design spec: {@link https://www.figma.com/design/QLhX4KcIViCdMD12xdfvXq/Coach?node-id=5864-77460&m=dev}
 *
 * @return ReactElement
 */
const AttendanceEarlySessionModalContainer: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <ModalComponent
            modalId={EModalId.AttendanceEarly}
            title={t("modals.earlyAttendance.title")}
            modalBodyClassName={classes.earlyAttendance.body()}
            modalHeaderClassName={classes.earlyAttendance.header()}
            withDisabledBodyScroll
            withCloseIcon
            withHideOnOutsideClick
            withHideOnEscapeClick
            withPortal
        >
            <ErrorBoundary fallback={<ErrorHint isVisible />}>
                <Loadable component={ModalBody} loadingFallback={<elements.Loader />} />
            </ErrorBoundary>
        </ModalComponent>
    )
}

AttendanceEarlySessionModalContainer.displayName = "AttendanceEarlySessionModalContainer"

export default AttendanceEarlySessionModalContainer
